<template>
<input type="hidden" :value="currentValue" :id="question.fieldName" />
</template>
<script>

export default {
  name: 'HiddenField',
  props: ['question', 'modelValue', 'errors', 'default', 'allowChange'],
  emits: ['update:modelValue'],
  data () {
    return {
    }
  },
  computed: {
    currentValue: {
      get () {
        return typeof this.modelValue !== 'undefined' ? this.modelValue : null
      },
      set (newValue) {
        this.$emit('update:modelValue', newValue)
      }
    }
  },
  methods: {
    setPrefilledValue () {
      if (this.question && (this.currentValue === undefined || this.currentValue === null)) {
        this.currentValue = this.question.prefilledValue
      }
    }
  },
  mounted () {
    this.setPrefilledValue()
  },
  watch: {
    question () {
      this.setPrefilledValue()
    }
  }
}
</script>
